import type { QueryClient } from '@tanstack/react-query'

// Re-read server facts after an operation or a reconnect; never advance stages locally.
const prefixes = new Set([
  'customer', 'customer-orders', 'customer-tasks', 'payments', 'payment', 'collection-overview',
  'finance-orders', 'uninvoiced-orders', 'invoices', 'invoice', 'receivable-invoices', 'invoice-payments',
  'order', 'orders', 'task-badges', 'approval-tasks', 'approval-task-detail', 'workflow-records',
  'workflow-voucher-assistance', 'workflow-pending-applications', 'workflow-direct-receivables',
  'workflow-unmatched-receipts', 'monthly-orders', 'monthly-order', 'monthly-company-orders',
  'monthly-company', 'monthly-reconciliation', 'certificates', 'pending-certificates',
  'dispatchable-devices', 'schedule-board', 'order-status-counts', 'engineer-task', 'engineer-tasks', 'mail-workbench', 'mail-daily-export', 'dispatch-overview',
  'inspection-records', 'refunds', 'exceptions', 'device', 'device-history', 'order-amount-summary',
])
export function refreshOrderTasks(client: QueryClient, options?: { keepDispatchSelections?: boolean }) {
  return client.invalidateQueries({ predicate: query => {
    const prefix = String(query.queryKey[0])
    return prefixes.has(prefix) && !(options?.keepDispatchSelections && prefix === 'dispatchable-devices')
  } })
}
